import { Variant } from "./Variant";
import { useContext } from "react";
import { AppPageVariantContext } from "./AppPageVariantContext";

export const useAppPageVariant = (): Variant => {
  return useContext(AppPageVariantContext);
};
